module.exports = __webpack_public_path__ + "assets/img/ftr-advantages-bg.a3cfd09c.png";